import { Password, Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import React, { useContext, useEffect, useState } from 'react';

import { Context as NavigationContext } from '@swf/components/StarsWizard/components/Navigation/Navigation';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import type { WizardContext } from '@swf/core/types/Wizard';

import Alert from '../../../Alert/Alert';
import Container from '../../../Container/Container';
import useDepositServicesData from '../../useDepositServicesData';

import {
  TXTCLI_Enter_Password,
  TXTCLI_Pending_Cashouts,
  TXTWCL_If_you_have_pending_withdrawal_ELL,
  TXTWCL_Just_so_you_know,
  TXTWCL_Pending_withdrawals_that_are_a_ELL,
  TXTWCL_Please_enter_your_PasswordX,
  TXTWCL_You_canXt_cancel_withdrawals_t_ELL,
  TXTWCL_You_have_1_pending_withdrawal__ELL,
  TXTWCL_You_have_N0_pending_withdrawal_ELL
} from './DepositPendingCashout.messages.json';
import { info } from './DepositPendingCashout.scss';
import PendingCashouts from './components/PendingCashouts/PendingCashouts';
import SubmitButton from './components/SubmitButton/SubmitButton';

const fieldName = 'pendingCashouts';

const DepositPendingCashout: React.FC = () => {
  const { data } = useWizardContext();
  const wizardContext = useWizardContext() as WizardContext;
  const { goPrevious } = useContext(NavigationContext);
  const { pendingCashouts: wizardPendingCashouts } = data;
  const [pendingCashouts, setPendingCashouts] = useState(wizardPendingCashouts);
  const services = useDepositServicesData();
  const singleTransaction = pendingCashouts.length === 1;
  const uniqueValues = new Set(pendingCashouts.map(({ balanceCurrency }) => balanceCurrency));

  useEffect(() => {
    if (data.processToPendingCashout) {
      delete data.processToPendingCashout;
      const fetchCashouts = async () => {
        const { pendingCashouts } = await services.getPendingCashouts();
        data.pendingCashouts = pendingCashouts;
        setPendingCashouts(pendingCashouts);
      };

      fetchCashouts();
    }
  }, [data, services]);
  const onBackClick = () => {
    delete wizardContext.values.password;
    goPrevious();
  };
  return (
    <Container
      headerProps={{
        title: <Translation {...TXTCLI_Pending_Cashouts} />,
        buttons: {
          back: true,
          onBackClick
        }
      }}
      page={DepositPendingCashout}
      pageTopTitle={
        <Translation
          {...(singleTransaction
            ? TXTWCL_You_have_1_pending_withdrawal__ELL
            : TXTWCL_You_have_N0_pending_withdrawal_ELL)}
          values={{ 0: pendingCashouts.length }}
        >
          {(message) => (
            <span>{message?.toString().substring(0, message?.toString().length - 1)}</span>
          )}
        </Translation>
      }
      helpSupportResolver
      showFooter
    >
      <>
        {uniqueValues.size > 1 ? (
          <Alert className={info} variant="info">
            <Translation tagName="b" {...TXTWCL_Just_so_you_know} />
            <p>
              <Translation {...TXTWCL_If_you_have_pending_withdrawal_ELL} />{' '}
              <Translation {...TXTWCL_You_canXt_cancel_withdrawals_t_ELL} />
            </p>
          </Alert>
        ) : (
          <Translation tagName="p" {...TXTWCL_Pending_withdrawals_that_are_a_ELL} />
        )}
        <PendingCashouts
          pendingCashouts={pendingCashouts}
          fieldName={`${fieldName}.transactions`}
        />
        <Password
          id="password"
          label={TXTCLI_Enter_Password}
          autoComplete="off"
          validators={[required(TXTWCL_Please_enter_your_PasswordX)]}
        />
        <SubmitButton fieldName={`${fieldName}.transactions`} />
      </>
    </Container>
  );
};

DepositPendingCashout.displayName = 'DepositPendingCashout';

export default DepositPendingCashout;
